/// <amd-module name="VSSUI/Components/Panel/Panel" />
import * as React from "react";

import { CustomPanel } from "./CustomPanel";
import { PanelContent } from "./PanelContent";
import { PanelFooter } from "./PanelFooter";
import { PanelHeader } from "./PanelHeader";
import { PanelOverlay } from "./PanelOverlay";
import { IPanelProps, IPanel } from "VSSUI/Components/Panel/Panel.Props";

let panelId = 1;

export class Panel extends React.Component<IPanelProps> implements IPanel {
    private readonly customPanelRef = React.createRef<CustomPanel>();
    private panelId = `panel-${panelId++}`;

    public render() {
        const { props } = this;
        const { backButtonProps, description, descriptionItem, footerButtonProps, onDismiss, overlayContent, showSeparator, titleProps = {} } = props;
        const id = props.id || this.panelId;
        const titleId = titleProps.id ? titleProps.id : titleProps.text ? `${id}-title` : undefined;
        return (
            <CustomPanel
                ariaLabelledBy={titleId}
                {...props}
                id={id}
                lightDismiss={overlayContent ? false : props.lightDismiss}
                ref={this.customPanelRef}
            >
                <PanelHeader
                    backButtonProps={backButtonProps}
                    description={!!descriptionItem ? descriptionItem: description}
                    onDismiss={onDismiss}
                    showSeparator={showSeparator}
                    titleProps={{ id: titleId, ...titleProps }}
                />
                <PanelContent className={props.contentClassName}>{props.children}</PanelContent>
                {footerButtonProps && <PanelFooter showSeparator={showSeparator} buttonProps={footerButtonProps} />}
                {overlayContent && <PanelOverlay overlayContent={overlayContent} />}
            </CustomPanel>
        );
    }

    public animateOut(): Promise<void> {
        return this.customPanelRef.current ? this.customPanelRef.current.animateOut() : Promise.resolve();
    }
}
